import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBenefitOptions } from '../../../../../global/ducks/benadmin-api';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { EnrollmentOptions } from '../models/new-hire-enrollment-models';
import { setNewHireEnrollmentOptions } from '../slice/new-hire-enrollment-slices';


export function useNewHireEnrollmentOptions(employerId: string, customQuery?: string, ignoreQuery?: boolean) {
	const enrollmentOptions = useSelector<TcsmStates, EnrollmentOptions>(state => state.newHireEnrollmentState?.enrollmentOptions);
	const dispatch = useDispatch();


	useEffect(() => {

		if ((!enrollmentOptions && employerId) && (customQuery || ignoreQuery)) {
			dispatch(getBenefitOptions(
				employerId,
				(response) => {
					dispatch(setNewHireEnrollmentOptions(response?.data));
				},
				null,
				customQuery,
			));
		}

	}, [employerId, customQuery]);

	return enrollmentOptions != null;
}